'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIploadProgressModule = require('./UIploadProgress.module.css');

var _UIploadProgressModule2 = _interopRequireDefault(_UIploadProgressModule);

var _reactHoc = require('@mindz/react-hoc');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ProgressIcon = function ProgressIcon(props) {
  return _react2.default.createElement('svg', props, _react2.default.createElement('defs', null, _react2.default.createElement('path', {
    id: 'a',
    d: 'M0 0h30v30H0z'
  })), _react2.default.createElement('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, _react2.default.createElement('mask', {
    id: 'b',
    fill: '#fff'
  }, _react2.default.createElement('use', {
    xlinkHref: '#a'
  })), _react2.default.createElement('g', {
    fill: '#FF4056',
    mask: 'url(#b)'
  }, _react2.default.createElement('path', {
    d: 'M25 12h-5a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1V7a1 1 0 1 0-2 0v5z'
  }), _react2.default.createElement('path', {
    d: 'M24.433 18.332a1 1 0 0 0-1.886-.664 8 8 0 1 1-11.416-9.66 8.01 8.01 0 0 1 9.544 1.36l4.64 4.36a1 1 0 1 0 1.37-1.457l-4.618-4.339a10 10 0 1 0 2.366 10.4z'
  }))));
};

ProgressIcon.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  width: '30',
  height: '30',
  viewBox: '0 0 30 30'
};

var UploadProgress = function UploadProgress(_ref) {
  var cx = _ref.cx;
  return _react2.default.createElement('div', {
    className: cx('root')
  }, _react2.default.createElement(ProgressIcon, null), _react2.default.createElement('span', null, "\u0141adowanie..."));
};

exports.default = (0, _reactHoc.withStyles)(_UIploadProgressModule2.default)(UploadProgress);
module.exports = exports.default;